<template>
  <li class="sort">
    <div class="sub-list-block">
      <ol class="sub-list">
        <li class="d-none d-sm-inline-block">目錄排序</li>
        <li class="d-none d-sm-inline-block">|</li>
        <li :class="{ selected: selectedMode === 1 }" class="pl-0">
          <a :href="newtoold">上架時間</a>
        </li>
        <li :class="{ selected: selectedMode === 4 }"><a :href="lowtohigh">價格高低</a></li>
        <li :class="{ selected: selectedMode === 5 }"><a :href="hottest">熱門商品</a></li>
      </ol>
    </div>
  </li>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const searchLocation = ref(window.location.search);
const keyStr = ref('OM=');
const selectedMode = ref(null);

const lowtohigh = computed(() => {
  return locationSearchFilter(4);
});
const newtoold = computed(() => {
  return locationSearchFilter(1);
});
const hottest = computed(() => {
  return locationSearchFilter(5);
});

function getOrderMode() {
  const args = searchLocation.value.split('&');

  let ModeStr = '';

  for (let i = 0; i < args.length; i++) {
    if (args[i].indexOf('OM') !== -1) {
      ModeStr = args[i];
    }
  }

  if (window.location.pathname === '/recent' && ModeStr.length === 0) {
    return 1;
  } else if (window.location.pathname === '/hot' && ModeStr.length === 0) {
    return 5;
  } else if (window.location.pathname === '/favorite' && ModeStr.length === 0) {
    return null;
  } else if (ModeStr.length === 0) {
    return 1;
  } else {
    return parseInt(ModeStr.charAt(ModeStr.length - 1));
  }
}

function locationSearchFilter(orderNum) {
  let argsString = '';
  if (window.location.toString().indexOf('?') !== -1) {
    const args = window.location.toString().split('?')[1].split('&');
    let i = 0;
    while (i < args.length) {
      if (args[i].indexOf('OM') !== -1) {
        args.splice(i, 1);
      } else if (args[i].indexOf('P=') !== -1) {
        args.splice(i, 1);
      } else {
        i++;
      }
    }
    if (args.length !== 0) {
      // 存在其他條件參數
      argsString = `${args.join('&')}&`;
    } else {
      argsString = `${args.join('&')}`;
    }
  }
  return '?' + argsString + keyStr.value + orderNum;
}

onMounted(() => {
  selectedMode.value = getOrderMode();
});
</script>
